import React, { Fragment } from "react";
import type { Mode } from "admin/type/type";

/**
 * 텍스트 내 줄바꿈 처리:
 * - \n → <br />
 * - {{mbr}} → 모바일에서만 <br />
 */
export const renderText = (
  text: string,
  mode?: Mode | string
): React.ReactNode => {
  // 먼저 \n으로 분리
  const lines = text.split("\n");
  return lines.map((line, lineIdx) => {
    // {{mbr}} 처리
    const parts = line.split("{{mbr}}");
    return (
      <Fragment key={lineIdx}>
        {lineIdx > 0 && <br />}
        {parts.map((part, partIdx) => (
          <Fragment key={partIdx}>
            {partIdx > 0 && mode === "Mobile" && <br />}
            {part}
          </Fragment>
        ))}
      </Fragment>
    );
  });
};
